<template>
  <div>
    <v-list>
      <v-list-item
        v-for="(contact, i) in contactsList"
        :key="i"
        :href="contact.base_link"
        target="_blank"
        rel="noopener noreferrer"
        class="primary--text px-4"
        @click.prevent="handleClickContact(contact)"
      >
        <v-list-item-icon class="mr-4">
          <v-icon
            v-if="isVisibleContactIcon(contact)"
            class="primary--text"
          >
            {{ contactMapIcons[contact.translit] }}
          </v-icon>
          <v-img
            v-else
            :src="contactMapIcons[contact.translit]"
            :alt="contact.name"
            width="24"
            height="24"
          />
        </v-list-item-icon>
        <v-list-item-content class="text-body-1 text--text">
          <div class="text-truncate">
            {{ getContactName(contact) }}
          </div>
        </v-list-item-content>
        <v-list-item-icon v-if="isVisibleArrow(contact)">
          <v-icon class="icon-secondary--text">
            ui-icon-arrow-right
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import I18NextVue from 'i18next'
import YaGoals from 'www/modules/YandexGoals'
import { getFormatPhoneNumber } from 'www/utils'
import toExternalPage from 'www/vue_components/common/DoctorContacts/functions'
import type { ApiDoctorContactsResponseGet } from 'www/vue_components/common/DoctorContacts/api/apiDoctorContacts.types'

type Contact = ApiDoctorContactsResponseGet[number]

const { t, language } = I18NextVue

const props = defineProps<{
  contactsList: Contact[]
  doctor: {
    id: number
    fio: string
  }
}>()

const contactMapIcons: Record<Contact['translit'], string> = {
  email: 'ui-icon-mail',
  phone: 'ui-icon-phone-call',
  'personal-site': 'ui-icon-site',
  'another-link': 'ui-icon-link-2',
  whatsapp: '/static/_v1/pd/icons/socials/whatsapp.png',
  telegram: '/static/_v1/pd/icons/socials/telegram.png',
  'vk-messenger': '/static/_v1/pd/icons/socials/vk-messenger.png',
  'blog-v-vk': '/static/_v1/pd/icons/socials/vk.png',
  'blog-v-dzen': '/static/_v1/pd/icons/socials/dzen.png',
  'blog-v-telegram': '/static/_v1/pd/icons/socials/telegram.png',
}
const isMobile = window.MOBILE_VERSION
const isVisiblePhone = ref(false)
const instanceYaGoals = new YaGoals()

const isVisibleContactIcon = (contact: Contact) => /^(ui-icon-).+/.test(contactMapIcons[contact.translit])
const isVisibleArrow = (contact: Contact) => !(contact.translit === 'phone' && isVisiblePhone.value)

const getContactName = (contact: Contact) => {
  if (contact.translit === 'phone') {
    if (isMobile) {
      return t('Позвонить', { ns: language })
    }

    if (isVisiblePhone.value) {
      return getFormatPhoneNumber(contact.display_link)
    }

    return t('Показать номер', { ns: language })
  }

  if (contact.translit === 'another-link') {
    return contact.display_link
  }

  return contact.name
}

const handleClickPhone = (contact: Contact) => {
  if (isMobile) {
    instanceYaGoals.send({ name: 'doctorContacts__clickPhoneOnMobile' })
    window.location.href = contact.base_link
    return
  }

  instanceYaGoals.send({ name: 'doctorContacts__clickPhoneOnDesktop' })

  isVisiblePhone.value = true
}

const handleClickContact = (contact: Contact) => {
  if (contact.translit === 'phone') {
    handleClickPhone(contact)
    return
  }

  if (contact.translit === 'email') {
    window.location.href = contact.base_link
    return
  }

  toExternalPage({
    doctorFio: props.doctor.fio,
    domain: contact.display_link,
    url: contact.base_link,
  })
}
</script>
